(function (angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var core = angular.module('Core');
	/*
	 * Extended form
	 *
	 * commands: {
	 *	applyData: Data are saved internally in the form and the dirty flag is set to false,
	 *	setDirty: Set dirty the global form
	 * }
	 */
	core.directive('stlFormGroup', ['$log', '$timeout', function ($log, $timeout) {
			/**
			 * Gives auto submit with form without any input type = sumbit
			 */
			return {
				restrict: 'E',
				scope: {
					editing: '=', // read / write
					editable: '=',
					formData: '=',
					save: '&',
					saveClose: '&',
					saveNew: '&',
					beforeCancel: '&',
					cancel: '&',
					close: '&',
					onDirty: '&',
					onStartEdit: '&',
					onEndEdit: '&',
					commands: '=?',
					commandsQueue: '=?'
				},
				replace: true,
				template:
						'<div class="stl-form-group" ng-class="{\'stl-form-group-editing\': editMode}" ng-transclude>' +
						'</div>',
				transclude: true,
				link: function (scope, element, attrs) {
					if (!attrs.editable) {
						scope.readOnly = false;
					} else {
						scope.$watch('editable', function (newVal) {
							scope.readOnly = !newVal;
						});
					}
					scope.handleSubmit = function () {
						if (scope.submit !== null && scope.submit !== '') {
							scope.submit();
						}
					};
				},
				controller: ['$scope', function ($scope) {

						var instance = this;
						var crtFormId = 0;
						var forms = [];
						var crtControlsId = 0;
						var controls = [];
						var formDataCopy = {};
						var focusableComponents = [];

						var registrationId = 0;

						var eventListeners = [];
						var sendEvents = function (event, data) {
							if (eventListeners.length) {
								for (var i = 0; i < eventListeners.length; i++) {
									var el = eventListeners[i];
									if (el.onFormEvent) {
										el.onFormEvent(event, data);
									}
								}
								$log.debug('stlFormGroup: events [' + event + '] sent.');
							}
						};

						this.addFormEventListener = function (listener) {
							eventListeners.push(listener);
							$log.debug('stlFormGroup: form event listener registered.');
						};

						var debug = function () {
							if ($scope.editMode) {
								$log.debug('stlFormGroup: Group is now in edition mode.');
							} else {
								$log.debug('stlFormGroup: Group is now in read only mode.');
							}
						};

						var saveFormData = function () {
							if ($scope.editMode) {
								// Make a copy of the data...
								formDataCopy = angular.copy($scope.formData);
								$log.debug('stlFormGroup: form data saved.');
							}
						};

						var update = function () {
							saveFormData();
							for (var i = 0; i < forms.length; i++) {
								forms[i].setEditMode($scope.editMode);
							}
							for (var j = 0; j < controls.length; j++) {
								controls[j].setEditMode($scope.editMode);
							}
							debug();
						};


						var updateFormControls = function () {
							for (var i = 0; i < controls.length; i++) {
								controls[i].setReadOnly($scope.readOnly);
							}
						};
						var setReadOnly = function (ro) {
							if (ro) {
								instance.setEditMode(false);
							}
							updateFormControls();
						};

						var setDirty = function (dirty) {
							for (var i = 0; i < forms.length; i++) {
								var form = forms[i];
								form.setDirty(dirty);
							}

							for (var j = 0; j < controls.length; j++) {
								var ctrl = controls[j];
								ctrl.setDirty(dirty);
							}

							$scope.dirty = dirty;
							if ($scope.onDirty !== undefined && $scope.onDirty !== null) {
								$scope.onDirty({dirty: dirty});
							}
						};

						/**
						 * Register a focusable component. Only 1 component could get the focus.
						 * @param {FC} fc contains an id and a function to call
						 */
						this.registerFocusableComponent = function (fc) {
							focusableComponents.push(fc);
						};
						/**
						 * Register a focusable component. Only 1 component could get the focus.
						 * @param {int} id the function to call to focus the element
						 */
						this.unregisterFocusableComponent = function (id) {
							for (var i = 0; i < focusableComponents.length; i++) {
								var fc = focusableComponents[i];
								if (fc.id === id) {
									// remove the focusable component...
									focusableComponents.splice(i, 1);
									break;
								}
							}
						};

						this.close = function () {
							if ($scope.close) {
								$scope.close();
							}
						};
						this.setEditMode = function (mode) {
							var diff = mode !== $scope.editMode;

							var edit = false;

							if (!diff) {
								return;
							}

							if (mode && $scope.onStartEdit) {
								$scope.onStartEdit();
								edit = true;
							}

							$scope.editMode = mode;
							update();

							if (!mode && $scope.onEndEdit) {
								$scope.onEndEdit();
							}

							if (edit && focusableComponents.length > 0) {
								focusableComponents[0].fn();
							}
						};

						this.getEditMode = function () {
							return $scope.editMode;
						};

						this.cancelEdition = function () {
							if ($scope.beforeCancel && $scope.beforeCancel()) {
								return; // Stop propagation enabled
							}

							sendEvents('beforeCancel');

							this.setEditMode(false);
							// restore the saved data...
							$scope.formData = formDataCopy;
							setDirty(false);
							$log.debug('stlFormGroup: form data restored.');
							if ($scope.cancel) {
								$scope.cancel({oldValue: formDataCopy});
							}

							sendEvents('afterCancel', {
								data: formDataCopy
							});
						};

						var callBeforeSave = function () {
							sendEvents('beforeSave');
						};
						var callAfterSave = function () {
							sendEvents('afterSave');
						};

						this.save = function () {
							callBeforeSave();
							var callbackFn = function () {
								instance.setEditMode(false);
								saveFormData();
								setDirty(false);
								callAfterSave();
							};
							if ($scope.save) {
								return $scope.save({fn: callbackFn});
							}
						};
						this.saveClose = function () {
							callBeforeSave();
							var callbackFn = function () {
								instance.setEditMode(false);
								saveFormData();
								setDirty(false);
								if (instance.close) {
									instance.close();
								}
								callAfterSave();
							};
							if ($scope.saveClose) {
								$scope.saveClose({fn: callbackFn});
							}
						};
						this.saveNew = function () {
							callBeforeSave();
							var callbackFn = function () {
								// Creation in edit mode = true...
								instance.setEditMode(true);
								saveFormData();
								setDirty(false);
								callAfterSave();
							};
							if ($scope.saveNew) {
								$scope.saveNew({fn: callbackFn});
							}
						};
						this.handleDirty = function () {
							var dirty = false;
							for (var i = 0; i < forms.length; i++) {
								var form = forms[i];
								if (form.dirty) {
									dirty = true;
									break;
								}
							}
							if (dirty !== $scope.dirty) {
								setDirty(dirty);
							}
						};

						$scope.valid = false;
						this.handleValid = function (form /* optional */) {

							var valid = true;

							if (form && forms.length > 1) { // Fast validate method. Used in register
								valid = $scope.valid && form.valid;
							} else {
								for (var i = 0; i < forms.length; i++) {
									var subform = forms[i];
									if (!subform.valid) {
										valid = false;
										break;
									}
								}
							}

							if ($scope.valid !== valid) {
								$scope.valid = valid;
								for (var j = 0; j < controls.length; j++) {
									controls[j].setValid($scope.valid);
								}
							}
						};

						this.registerForm = function (form) {
							crtFormId++;
							registrationId++;
							forms.push(form);
							form.setEditMode($scope.editMode);
							this.handleValid(form);

							form.registrationId = registrationId;

							$log.debug('stlFormGroup: form with registration id ' + registrationId + ' is registerd.');

							return registrationId;
						};
						this.unregisterForm = function (_registrationId) {
							for (var i = 0; i < forms.length; i++) {
								var form = forms[i];
								if (form.registrationId === _registrationId) {
									forms.splice(i, 1);
								}
							}
							this.handleValid();

							$log.debug('stlFormGroup: form with registration id ' + _registrationId + ' is UNregisterd.');
						};
						this.registerFormControls = function (control) {
							crtControlsId++;
							controls.push(control);
							control.setEditMode($scope.editMode);
							control.setReadOnly($scope.readOnly);
							control.setValid($scope.valid);
						};


						$scope.$watch('readOnly', function (newVal, oldVal) {
							if (newVal !== oldVal) {
								setReadOnly(newVal);
							}
						});
						$scope.$watch('editing', function (newVal, oldVal) {
							if (newVal !== undefined && newVal !== null && newVal !== oldVal) {
								$scope.editMode = $scope.editing;
								update();
							}
						});
						$scope.editMode = false;
						if ($scope.editing !== undefined && $scope.editing !== null) {
							$scope.editMode = $scope.editing;
							saveFormData();


							if ($scope.editMode && $scope.onStartEdit) {
								$scope.onStartEdit();
							}
						}

						// Dump all required variable from this form group
						var dumpState = function () {
							return {
								originalData: formDataCopy,
								userData: $scope.formData,
								dirty: $scope.dirty,
								edit: $scope.editMode
							};
						};
						// restore state previously dumped
						var restoreState = function (data) {
							formDataCopy = data.originalData;
							$scope.formData = data.userData;
							setDirty(data.dirty);
							instance.setEditMode(data.edit);
						};

						// add commands to this form
						var handleCommand = function (action, options) {
							var ret = null;
							$log.debug('stlFormGroup: handling action ' + action + '...');
							if (action === 'applyData') {
								saveFormData();
								setDirty(false);
							} else if (action === 'dump') {
								ret = dumpState();
							} else if (action === 'restore') {
								$log.error('stlFormGroup: action "restore" is disabled !');
								//restoreState(options.data);
							} else if (action === 'setDirty') {
								setDirty(options.dirty);
							} else if (action === 'save') {
								return instance.save();
							} else if (action === 'setEditMode') {
								instance.setEditMode(options);
							} else {
								$log.error('stlFormGroup: no action available for ' + action + ' option: [' + options + '].');
							}
							$log.debug('stlFormGroup: action ' + action + ' handled.');
							return ret;
						};

						$scope.$watch('commandsQueue', function (commands) {
							if (commands !== undefined && commands !== null) {

								// Let's handle commands
								for (var i = 0; i < commands.length; i++) {
									var c = commands[i];
									handleCommand(c.action, c.options);
								}

								$scope.commandsQueue = [];
							}
						}, true);

						$scope.commands = function (action, options) {
							return handleCommand(action, options);
						};

						this.sendCommand = function (action, options) {
							handleCommand(action, options);
						};

						debug();
					}]
			};
		}]);
	/**
	 * Extended form
	 */
	core.directive('stlForm', function (Language, $timeout, $log) {
		var formId = 0;
		/**
		 * Gives auto submit with form without any input type = sumbit
		 */
		return {
			require: ['^?stlFormGroup', 'stlForm'],
			restrict: 'E',
			scope: {
				submit: '&',
				title: '=',
				detached: '@',
				editable: '=?',
				stlFormShow: '=?',
				controller: '=?'
			},
			replace: true,
			template: function () {
				return '<form ng-show="m.shown" name="stlForm' + formId++ + '" ng-submit="handleSubmit()" class="app-form form-horizontal" no-validate>' +
						'	<input type="submit" style="visibility:hidden; position: absolute;top: 0px;"></input>' +
						'	<div class="panel panel-form" ng-transclude>' +
						'	</div>' +
						'</form>';
			},
			transclude: true,
			link: function (scope, element, attrs, ctrl) {
				var formGroup = null;
				if (ctrl[0]) {
					formGroup = ctrl[0];
				}
				scope.controller = ctrl[1];
				scope.editMode = false;
				scope.hasEditAttr = false;
				scope.m = {};
				if (attrs['editable'] !== undefined) {
					scope.editable = false;
				} else {
					scope.editable = true;
				}

				scope.registrationId = null;

				var form = attrs.name;
				scope.form = form;
				scope.formName = form;

				scope.handleSubmit = function () {
					if (scope.submit !== null && scope.submit !== '') {
						scope.submit();
					}
				};
				scope.dirty = false;
				scope.$watch(form + '.$dirty', function (newVal, oldVal) {
					if (newVal !== oldVal && newVal !== scope.dirty) {
						scope.dirty = newVal;
						if (formGroup) {
							formGroup.handleDirty();
						}
					}
				});
				scope.setDirty = function (dirty) {
					if (dirty) {
						scope[form].$setDirty();
					} else {
						scope[form].$setPristine();
					}
					scope.dirty = dirty;
				};

				var register = function () {
					if (formGroup && !scope.detached === true) {
						scope.registrationId = formGroup.registerForm(scope);
					}
				};

				// Watch form validity
				scope.valid = scope[form].$valid;
				scope.$watch(form + '.$valid', function (newVal, oldVal) {
					if (formGroup && newVal !== undefined && newVal !== null && newVal !== scope.valid) {
						scope.valid = newVal;
						formGroup.handleValid();
					}
				});

				scope.m.shown = false;
				if (!attrs['stlFormShow'] || scope.stlFormShow && scope.stlFormShow === true) {
					scope.m.shown = true;
					register();
				}

				scope.isFormGroupEditing = function () {
					var editing = false;
					if (formGroup) {
						editing = formGroup.getEditMode();
					}
					return editing;
				};

				var unregister = function () {
					if (formGroup) {
						formGroup.unregisterForm(scope.registrationId);
					}
				};
				scope.$on('$destroy', function () {
					unregister();
				});

				scope.$watch('stlFormShow', function (newVal) {
					if (newVal !== scope.m.shown) {
						if (newVal === true) {
							$timeout(function () {
								scope.m.shown = true;
								register();
								if (formGroup) {
									formGroup.handleValid();
								}
							});
						} else if (newVal === false) {
							$timeout(function () {
								scope.m.shown = false;
								unregister();
							});
						}
					}
				});
			},
			controller: ['$scope', function ($scope) {
					var rws = [];
					var crtRWId = 0;

					$scope.setEditMode = function (editMode) {
						var edit = editMode;
						if ($scope.editable !== undefined && $scope.editable !== null) {
							edit = edit && $scope.editable === true;
						}
						if (edit !== $scope.editMode) {
							$scope.editMode = edit;
							// Call children...
							for (var i = 0; i < rws.length; i++) {
								rws[i].setEditMode($scope.editMode);
							}
						}
					};

					// Re call setEditMode to apply the editable changes
					$scope.$watch('editable', function (newVal) {
						if (newVal !== undefined && newVal !== null) {
							$scope.setEditMode($scope.isFormGroupEditing());
						}
					});

					this.getForm = function () {
						return $scope[$scope.formName];
					};

					// Register a rw component
					this.register = function (rw) {
						crtRWId++;
						rws.push(rw);
						rw.setEditMode($scope.editMode);
					};

					/*
					 * @deprecated
					 */
					this.getFormObject = function () {
						return $scope[$scope.formName];
					};

					this.initSubScope = function (scope) {
						scope.locale = Language.current().toUpperCase();
						scope.form = $scope[$scope.formName];

						scope.isEmpty = function (input) {
							if (scope.form[input] === undefined) {
								return;
							}
							return scope.form[input].$isEmpty(scope.form[input].$modelValue);
						};
					};

					this.isEditing = function () {
						return $scope.editMode;
					};

					/**
					 * Used by form components to call the default action (submit)
					 */
					this.submit = function () {
						$scope.handleSubmit();
					};
				}]
		};
	});
	core.directive('stlFormHead', ['$timeout', function ($timeout) {
			return {
				restrict: 'E',
				scope: {
				},
				replace: true,
				template:
						'<div class="panel-heading" >{{editMode}}<span ng-transclude class="stl-form-head"></span></div>',
				transclude: true
			};
		}]);
	core.directive('stlFormContent', [function () {
			return {
				restrict: 'E',
				/*scope: {
				 },*/
				replace: true,
				template:
						'<div class="panel-body">' +
						'	<div ng-transclude></div>' +
						'</div>',
				transclude: true
			};
		}]);
	core.directive('stlFormControls', [function () {
			return {
				require: '^stlFormGroup',
				restrict: 'E',
				scope: {
					btnSaveAndNew: '=',
					hiddeBtns: '@?',
					valid: '=?'
				},
				replace: true,
				templateUrl: 'components/core/form/core-form-controls.html',
				transclude: true,
				link: function (scope, element, attrs, formGroup) {
					var btnsList = ['close', 'edit', 'cancel', 'save', 'saveClose'];

					var hiddeBtns = {};
					if (scope.hiddeBtns) {
						var hiddeBtnsList = scope.hiddeBtns.split(',');
						for (var i = 0; i < hiddeBtnsList.length; i++) {
							hiddeBtns[hiddeBtnsList[i]] = true;
						}
					}

					for (var j = 0; j < btnsList.length; j++) {
						if (!hiddeBtns[btnsList[j]]) {
							scope[btnsList[j] + 'Btn'] = true;
						}
					}

					scope.readOnly = true;
					scope.dirty = false;
					scope.edit = function () {
						formGroup.setEditMode(true);
					};
					scope.cancel = function () {
						formGroup.cancelEdition();
					};
					scope.save = function () {
						formGroup.save();
					};
					scope.saveClose = function () {
						formGroup.saveClose();
					};
					scope.saveNew = function () {
						formGroup.saveNew();
					};
					scope.setReadOnly = function (ro) {
						scope.readOnly = ro;
					};
					scope.setDirty = function (dirty) {
						scope.dirty = dirty;
					};
					scope.editMode = false;
					scope.setEditMode = function (editMode) {
						scope.editMode = editMode;
					};

					scope.valid = true;
					scope.setValid = function (valid) {
						scope.valid = valid;
					};


					scope.close = function () {
						formGroup.close();
					};

					formGroup.registerFormControls(scope);
				},
				controller: ['$scope', function ($scope) {
						this.crtId = 0;
						var instance = this;
						$scope.buttonsShown = 0;
						this.registerButton = function () {
							$scope.buttonsShown++;
							return instance.crtId++;
						};
						this.unRegisterButton = function (btnId) {
							$scope.buttonsShown = $scope.buttonsShown - 1;
						};
					}
				]
			};
		}]);
	core.directive('stlFormControlsBtn', ['$timeout', function ($timeout) {
			return {
				require: '^stlFormControls',
				restrict: 'A',
				scope: false,
				link: function (scope, element, attrs, controls) {
					var btnId = controls.registerButton();
					element.bind('$destroy', function () {
						$timeout(function () {
							controls.unRegisterButton(btnId);
						});
					});
				}
			};
		}]);

	core.directive('stlInputField', ['$translate', '$timeout', function ($translate, $timeout) {

			return {
				restrict: 'E',
				scope: {
					ngModel: '=',
					enum: '@',
					formatter: '&',
					labelTooltip: '=?'
				},
				replace: true,
				transclude: true,
				template: function (e, a) {

					var specificParameters = ['label-col', 'label-text', 'input-col', 'input-id', 'input-btns', 'inputsize', 'labelsize', 'labelkey', 'inputid', 'ngModel', 'enum'];
					var normalParameters = '';
					for (var key in a) {
						if (!(key.indexOf('$') === 0) && specificParameters.indexOf(key) === -1) {
							normalParameters += key + '="' + a[key.toString()] + '"';
						}
					}

					var labelCol = 0;
					if (e.attr('label-col')) {
						labelCol = e.attr('label-col');
					}

					var inputCol = 12 - labelCol;
					if (e.attr('input-col')) {
						inputCol = e.attr('input-col');
					}

					var labelText = '0';
					if (e.attr('label-text')) {
						labelText = e.attr('label-text');
					}

					var inputId = labelText;
					if (e.attr('input-col')) {
						inputCol = e.attr('input-col');
					}

					var type = 'text';
					if (e.attr('type')) {
						type = e.attr('type');
					}

					var btns = [];
					if (e.attr('input-btns')) {
						btns = angular.fromJson(e.attr('input-btns'));
					}

					var tpl = '';
					tpl += '<div class="form-group">';
					if (labelCol > 0) {
						tpl += '<label for="' + inputId + '" class="col-sm-' + labelCol + ' control-label" translate="' + labelText + '">' + labelText + '</label>';
					}
					tpl += '<div class="col-sm-' + inputCol + '">';

					if (type === 'text' && btns.length === 0) {
						tpl += '<input type="text" class="form-control input-sm" id="' + inputId + '">';
					} else if (type === 'text' && btns.length > 0) {
						tpl += '<div class="input-group">';
						tpl += '	<input type="text" class="form-control input-sm" id="' + inputId + '">';
						tpl += '	<span class="input-group-btn">';
						btns.forEach(function (item) {
							var primary = item.primary ? ' btn-primary' : '';
							tpl += '	<button class="btn' + primary + ' btn-xs btn-default input-sm" type="button" onclick="asdf()">';
							tpl += '		<span class="' + item.icon + '" aria-hidden="true">';
							tpl += '	</button>';
						});
						tpl += '	</span>';
						tpl += '</div>';


						/*
						 <input type="text" class="form-control input-sm" id="exampleInputName2" />
						 <span class="input-group-btn">

						 <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>

						 <button class="btn btn-default btn-xs input-sm" type="button">
						 <span class="glyphicon glyphicon-ok" aria-hidden="true">
						 </button>
						 </span>
						 */
					} else {
						tpl += 'Unsupported field type: ' + type;
					}

					tpl += '	</div>';
					tpl += '</div>';

					return tpl;
				},
				link: function (scope, element, attrs, form) {

					if (scope.enum) {
						scope.enumValue = '\'' + element.attr('enum') + '.FR\' | translate';
						console.log(scope.enumValue);
					}

					scope.load = true;
					$timeout(function () {
						scope.load = false;
					}, 3000);
				}
			};
		}]);
	/*
	 core.directive('stlInputField', ['$translate', '$timeout', function ($translate, $timeout) {

	 return {
	 restrict: 'E',
	 scope: {
	 ngModel: '=',
	 enum: '@',
	 formatter: '&',
	 labelTooltip: '=?'
	 },
	 replace: true,
	 transclude: true,
	 template: function (e, a) {

	 var specificParameters = ['inputsize', 'labelsize', 'labelkey', 'inputid', 'ngModel', 'enum'];
	 var normalParameters = '';
	 for (var key in a) {
	 if (!(key.indexOf('$') === 0) && specificParameters.indexOf(key) === -1) {
	 normalParameters += key + '="' + a[key.toString()] + '"';
	 }
	 }

	 var inputSize = 1;
	 if (e.attr('inputSize')) {
	 inputSize = e.attr('inputSize');
	 }
	 var labelSize = 1;
	 if (e.attr('labelSize')) {
	 labelSize = e.attr('labelSize');
	 }
	 var label = '';
	 if (e.attr('labelKey')) {
	 label = e.attr('labelKey');
	 }
	 var inputId = '';
	 if (e.attr('inputId')) {
	 inputId = e.attr('inputId');
	 }

	 var templ = '<div><label for="' + inputId + '" class="col-md-' + labelSize + ' control-label" translate="' + label + '">TODO Label</label>'
	 + '<div class="col-md-' + inputSize + '">'
	 + '<input id="' + inputId + '"';
	 //if (enumeration !== '') {
	 templ += ' value=" {{ $scope.enumValue }}" ';
	 //	} else {
	 templ += ' ng-model="ngModel" ';
	 //	}
	 templ += ' class="form-control" ' + normalParameters + ' />'
	 + '</div></div>';
	 return templ;
	 },
	 link: function (scope, element, attrs, form) {

	 if (scope.enum) {
	 scope.enumValue = '\'' + element.attr('enum') + '.FR\' | translate';
	 console.log(scope.enumValue);
	 }

	 scope.load = true;
	 $timeout(function () {
	 scope.load = false;
	 }, 3000);
	 }
	 };
	 }]);

	 */


	/**
	 * Directive that provides a read / edit mode of the child directive.
	 * To fill the read only label, you have 2 possibilities
	 *	1) Use the directive stl-rw-emitter on the child component (input)
	 *	2) Use "text" directive to force a value to this field
	 *
	 * formatter attribute is a function available in the form scope that is used to format the ng-model value (optional)
	 *
	 */
	core.directive('stlReadWrite', ['$timeout', function ($timeout) {
			var getReadValue = function (value) {
				if (value !== undefined && value !== null && value !== NaN) {
					return value;
					//return $sce.trustAsHtml(value + ''); <- NEVER DO THIS
				} else {
					return '';
				}
			};
			return {
				require: '^?stlForm',
				restrict: 'E',
				scope: {
					text: '=',
					formatter: '&',
					labelTooltip: '=?'
				},
				replace: true,
				template: function (e, a) {
					var size = 7;
					if (a['size']) {
						size = a['size'];
					}
					var tooltip = '';
					if (a['labelTooltip']) {
						tooltip = 'stl-tooltip="labelTooltip"';
					}
					return '<div class="col-md-' + size + ' stl-read-write">' +
							'	<label class="stl-read-write-label" ng-if="!editMode"><span ng-bind-html="readValue"  ' + tooltip + '></span></label>' +
							'	<div class="stl-read-write-cmpnt" ng-if="!load" ng-show="editMode" ng-transclude></div>' +
							'</div>';
				},
				transclude: true,
				link: function (scope, element, attrs, form) {
					scope.load = true;
					$timeout(function () {
						scope.load = false;
					}, 3000);
					scope.$watch('editMode', function (newValue, oldValue) {
						if (scope.load && scope.editMode) {
							scope.load = false;
						}
					});

					scope.test = 'ttt';

					if (attrs['noBootstrap']) {
						$(element).removeClass('col-md-7');
					}

					scope.editMode = false;
					if (scope.text) {
						scope.readValue = getReadValue(scope.text);
					} else {
						scope.readValue = getReadValue('');
					}
					if (!attrs.formatter) {
						scope.formatter = null;
					}

					scope.setEditMode = function (editMode) {
						scope.editMode = editMode;
					};
					scope.$watch('text', function (newVal, oldVal) {
						if (newVal !== oldVal || scope.readValue !== newVal) {
							scope.readValue = getReadValue(newVal);
						}
					}, true);

					if (form) {
						form.register(scope);
					}
				},
				controller: ['$scope', function ($scope) {
						this.dataLabel = '';
						this.setDataLabel = function (value) {
							if ($scope.text === undefined) {
								if ($scope.formatter !== null) {
									this.dataLabel = $scope.formatter({value: value});
								} else {
									this.dataLabel = value;
								}
								$scope.readValue = getReadValue(this.dataLabel);
							}
						};
					}
				]
			};
		}]);
	/*
	 * Send event to the parent scope when the ng-model changes
	 * Need to be used to auto fill the data label from stl-read-write
	 */
	core.directive('stlRwEmitter', [function () {
			return {
				require: '^stlReadWrite',
				restrict: 'A',
				scope: {
					ngModel: '='
				},
				link: function (scope, element, attrs, stl) {
					scope.$watch('ngModel', function (newVal, oldVal) {
						if (newVal !== oldVal) {
							stl.setDataLabel(newVal);
						}
					});
				}
			};
		}]);
	core.directive('stlLabelInput', [function () {
			return {
				restrict: 'E',
				transclude: true,
				scope: {
					i18n: '@'
				},
				template:
						'<div class="form-group">' +
						'<label class="col-md-5 control-label stl-label"><i18n key="{{i18n}}"></label>' +
						'<div class="col-md-7 stl-read-write">' +
						'<div class="stl-read-write-cmpnt" ng-transclude></div>' +
						'</div>' +
						'</div>'
			};
		}]);
	/*
	 * STL Label
	 */
	core.directive('stlLabel', [function () {
			return {
				restrict: 'E',
				replace: true,
				template: function (e, a) {
					var size = 5;
					if (a['size']) {
						size = a['size'];
					}
					return '<label class="col-md-' + size + ' control-label stl-label" ng-transclude></label>';
				},
				transclude: true,
				link: function (scope, element, attrs, stl) {
					scope.$watch('ngModel', function (newVal, oldVal) {
						if (newVal !== oldVal) {
							stl.setDataLabel(newVal);
						}
					});
				}
			};
		}]);
	core.directive('stlFormLine', [function () {
			var REQUIRED_PREFIX = 'RE_';
			var WANTED_PREFIX = 'WA_';
			return {
				restrict: 'AE',
				compile: function (element, attributes) {

					var required = attributes['stlRequired'] !== undefined;
					var wanted = attributes['stlWanted'] !== undefined;
					var attributeName = attributes['stlFormLine'];
					var requiredAttribute = REQUIRED_PREFIX + attributeName;
					var wantedAttribute = WANTED_PREFIX + attributeName;

					var setLabel = function () {
						if (required) {
							$(this).append(
									'<span >' +
									' *' +
									'</span>');
						} else {
							$(this).append(
									'<span ' +
									'ng-if="' + requiredAttribute + ' !== undefined && ' +
									requiredAttribute + ' === true " >' +
									' *' +
									'</span>');
						}
					};

					$('label.control-label', element).each(setLabel);
					$('stl-label', element).each(setLabel);

					var inputUpdate = function (el, input) {
						if (input === undefined) {
							input = el;
						}
						var inputName = attributeName;
						if ($(input).attr('name') !== undefined) {
							inputName = $(el).attr('name');
						} else {
							$(input).attr('name', inputName);
						}
						//ng-class="{'input-error':form.nom.$error.required}"
						if (required) {
							$(el).attr('ng-class',
									'{' +
									'"input-error": ' +
									'form.' + inputName + '.$error.required ' +
									'}'
									);

							$(input).attr('ng-required', true);
						} else if (wanted) {
							$(el).attr('ng-class',
									'{' +
									'"input-wanted": ' +
									'isEmpty("' + inputName + '") ' +
									'}'
									);
						} else {
							$(el).attr('ng-class',
									'{' +
									'"input-error": ' +
									'form.' + inputName + '.$error.required && ' +
									requiredAttribute + ' !== undefined && ' +
									requiredAttribute + ' === true ' +
									',' +
									'"input-wanted": ' +
									'isEmpty("' + inputName + '") && ' +
									wantedAttribute + ' !== undefined && ' +
									wantedAttribute + ' === true ' +
									'}'
									);

							$(input).attr('ng-required', requiredAttribute);
						}

					};

					//stl - date - picker

					$(':input', element).each(function () {
						var el = this;
						if ($(this).attr('type') !== undefined && $(this).attr('type').toLowerCase() === 'radio') {
							el = $('stl-read-write', element);
						}
						inputUpdate(el, this);
					});

					$('stl-date-picker', element).each(function () {
						inputUpdate(this);
					});


				}
			};

		}]);

	core.directive('stlIsError', function () {
		return {
			restrict: 'A',
			link: function (scope, element, attribute, controller) {
				$(element).on('keyup', function () {
					if (scope.form[attribute['name']].$valid) {
						$(element).removeClass('input-error');
					} else {
						$(element).addClass('input-error');
					}
				});
			}
		};
	});
	core.directive('focusAware', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
			var id = 0;
			return {
				restrict: 'A',
				scope: true,
				require: '^?stlFormGroup',
				link: function (scope, element, attrs, formGroup) {
					id++;
					scope.id = id;
					var focusMe = function () {
						$timeout(function () {
							var inputs = element.find(':input');
							if (inputs && inputs.length > 0) {
								for (var i = 0; i < inputs.length; i++) {
									var input = inputs[i];
									var ji = $(input);
									if (ji.is(':visible')) {
										ji.focus();
										break;
									}
								}
							} else {
								element.focus();
							}
						}, 50);
					};

					// VAR NAME
					var fcName = attrs['focusAware'];

					$rootScope.$on('send-focus', function (event, name) {
						if (fcName && fcName === name) {
							focusMe();
						}
					});

					// Register focus...
					if (formGroup) {
						var fc = {
							id: scope.id,
							fn: focusMe
						};
						formGroup.registerFocusableComponent(fc);
					}

					if (formGroup) {
						element.bind('$destroy', function () {
							$timeout(function () {
								formGroup.unregisterFocusableComponent(scope.id);
							});
						});
					}
				}
			};
		}]);

	core.directive('stlSelect', ['$log', function ($log) {
			return {
				restrict: 'A',
				require: 'select',
				link: function (scope, element, attrs, formGroup) {
					var watch = true;
					var observerMode = null;
					var observer = null;

					var destroyObservers = function () {
						$log.debug('stlSelect: Destroying observers [' + observerMode + ']...');
						if (observerMode === 'DOMEvent') {
							$(element).unbind('DOMSubtreeModified');
						} else if (observerMode === 'MutationObserver') {
							observer.disconnect();
						}
					};


					var redraw = function () {
						// Créé un nouvel élément qui sera inséré puis supprimé dans le select pour forcer son rendu
						var option = document.createElement('option');
						var control = $(element)[0];
						control.add(option, 0);
						try {
							control.remove(0);
						} catch (e) {
							$log.info('stlSelect: Bug in IE: ' + e);
						}
						watch = false;
					};

					var onChange = function (mutations) {
						if (watch === true) {
							setTimeout(redraw, 200);
						}
						watch = true;
					};


					var initObserver = function () {
						$log.debug('stlSelect: Initializing observers...');
						var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

						if (MutationObserver) {
							observerMode = 'MutationObserver';
							observer = new MutationObserver(function (mutations) {
								onChange(mutations);
							});
							observer.observe($(element)[0], {
								attributes: true,
								childList: true,
								characterData: true,
								subtree: true
							});
						} else {
							observerMode = 'DOMEvent';
							$(element).bind('DOMSubtreeModified', function () {
								onChange();
							});
							$(element).bind('click', function () {
								watch = false;
							});
						}
						$log.debug('stlSelect: Observer: ' + observerMode);

						scope.$on('$destroy', function () {
							destroyObservers();
						});
					};

					// Only when IE...
					if (GLOBALVARS.browser.type === 'ie') {
						initObserver();
					}
				}
			};
		}]);

	core.directive('stlStaticControl', function (toaster, $translate) {
		return {
			restrict: 'E',
			scope: {
				value: '@value'
			},
			link: function (scope, element, attrs) {
				scope.onClipboardSuccess = function (e) {
					e.clearSelection();
					toaster.pop('note', '', $translate.instant('msg.CopieDansLePressePapier') + ': ' + e.text, 2000);
				};
			},
			template: function (element, attributes) {
				var labelWidth = 2;
				var fieldWidth = 12 - labelWidth;
				var label = '';
				var id = '';
				var idAttribute = '';
				var clip = '';

				if (angular.isDefined(attributes['labelWidth'])) {
					labelWidth = parseInt(attributes['labelWidth'], 10);
				}

				if (angular.isDefined(attributes['fieldWidth'])) {
					fieldWidth = parseInt(attributes['fieldWidth'], 10);
				}

				if (angular.isDefined(attributes['contentId'])) {
					id = attributes['contentId'];
					idAttribute = ' id="' + id + '"';
				}

				if (angular.isDefined(attributes['clipable'])) {
					clip = '<span ngclipboard data-clipboard-target="#' + id + '" ngclipboard-success="onClipboardSuccess(e);" class="iconbtn iconexp iconexp-copy" aria-label="Copied!"></span>';
				}

				if (angular.isDefined(attributes['translateKey'])) {
					var translateKey = attributes['translateKey'];
					label = '<label class="col-md-' + labelWidth + ' control-label" translate="' + translateKey + '">' + translateKey + '</label>';
				}

				return	'<div>' +
						label +
						'	<div class="col-md-' + fieldWidth + '">' +
						'		<p class="form-control-static"' + idAttribute + '>{{value}}' +
						clip +
						'		</p>' +
						'	</div>' +
						'</div>';
			}
		};
	});

})(angular);
